// extracted by mini-css-extract-plugin
module.exports = {"loading":"PageLoading_loading__2CM59","loadingShrink":"PageLoading_loadingShrink__19JIR"};